@if (mapLoaded && !sessionExpired) {
  <div class="whole-app">
    <app-loader></app-loader>
    <router-outlet></router-outlet>
  </div>
}

@if (sessionExpired) {
  <div class="session-expired">
    <img [src]="logoUrl" alt="logo" class="eld-logo" />
    <p>SESSION EXPIRED</p>
    <p>
      <button mat-flat-button color="primary" class="refresh" (click)="onReload()">
        {{ 'buttons.refreshPage' | translate }}
      </button>
    </p>
  </div>
}
<app-svg-holder></app-svg-holder>
